import createActionType from "@/redux/utils/createActionType";

export const MODULE = "sales-order/search-filter";

export const SET_SEARCH = createActionType(MODULE, "setSearch");

export const RESET = createActionType(MODULE, "reset");
